'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderWishIcon = exports.ProductWishIcon = undefined;

var _ProductWishIcon2 = require('./ProductWishIcon/ProductWishIcon');

var _ProductWishIcon3 = _interopRequireDefault(_ProductWishIcon2);

var _HeaderWishIcon2 = require('./HeaderWishIcon/HeaderWishIcon');

var _HeaderWishIcon3 = _interopRequireDefault(_HeaderWishIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ProductWishIcon = _ProductWishIcon3.default;
exports.HeaderWishIcon = _HeaderWishIcon3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/WishList/index.js
// module id = 1792
// module chunks = 0